import {GET_DOCUMENTS} from "../../../../enums/Profile/profile";

export const getDocumentsInformationAction = (data)=>{
    return{
        type:GET_DOCUMENTS,
        payload:data,
    };
};
